import { Button, Icon, Paper, styled } from "@mui/material";

export const StyledCustomList = {
  StyledPaper: styled(Paper)(({ theme }) => ({
    minWidth: 250,
    width: "calc(100vw / 4)",
    height: "calc(100vh - 270px)",
    border: "1px solid #f1f1f1",
    overflow: "auto",
    backgroundColor: "#e6e6e64f",
    boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.1)",
  })),
  TextStatus: styled("p")(({ theme, color }) => ({
    fontFamily: "Roboto, sans-serif",
    fontSize: "small",
    marginTop: -10,
    marginLeft: 10,
    color: color || "inherit",
  })),
  Text: styled("p")({
    fontWeight: "bold",
    color: "#303030",
    fontFamily: "Roboto, sans-serif !important",
  }),
  ListItemIconContainer: styled("div")({
    display: "flex",
    justifyContent: "row",
    alignItems: "center",
  }),
};

export const StyledTransferList = {
  Root: styled("div")({
    margin: "0px 0px 27px 0px",
    minWidth: "100%",
    minHeight: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  }),

  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(0.5, 0),
    border: "1px solid black",
  })),

  ContainerLodash: styled("div")({
    display: "table-cell",
    verticalAlign: "middle",
    textAlign: "center",
  }),

  Alert: styled("p")({
    color: "red",
    fontFamily: "Roboto, sans-serif",
    maxWidth: "150px",
  }),

  Text: styled("div")(({ theme }) => ({
    fontFamily: "Roboto, sans-serif",
    fontSize: "medium",
    margin: 0,
    padding: "0px 0px 0px 12px",
    color: "#606060",
    fontWeight: "bold",
    flex: 1,
    backgroundColor: "#f1f1f1",
    marginBottom: 8,
    cursor: "default",
    borderRadius: 2,
    boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
  })),

  Title: styled("p")({
    fontSize: "large",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    color: "#484848",
    marginLeft: "25px",
    marginBottom: 7,
  }),

  StyledIcon: styled(Icon)({
    marginRight: 10,
  }),
};
